import React, {FC, useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {MaybeNumber} from "../../types/Maybe";
import {textToFloat} from "../../tools";

interface Props {
    label: string | React.ReactElement;
    value: MaybeNumber;
    onChange?: (newValue: number) => void;
    visible?: boolean;
    required?: boolean;
    disabled?: boolean;
    labelClass?: string;
    fieldClass?: string;
    groupClass?: string;
    formatter?: (value: MaybeNumber) => string;
}

const NumberInputField: FC<Props> = (props) => {
    const [value, setValue] = useState("");

    const formatValue = (val: MaybeNumber) => {
        if (props.formatter) return props.formatter(val);
        return val?.toString() || "";
    };

    useEffect(() => {
        setValue(formatValue(props.value));
    }, [props.value]);

    function handleBlur() {
        if (props.onChange) {
            const newValue = textToFloat(value) || 0;
            setValue(formatValue(newValue));
            props.onChange(newValue);
        }
    }

    if (props.visible === false) {
        return null;
    }

    return (
        <Form.Group className={props.groupClass}>
            {
                props.label &&
                <Form.Label className={props.labelClass}>{props.label}
                    {
                        props.required && <span className={"text-danger"}>*</span>
                    }
                </Form.Label>
            }
            <Form.Control
                required={props.required}
                disabled={props.disabled || !props.onChange}
                className={props.fieldClass}
                value={value || ""}
                onChange={event => setValue(event.target.value)}
                onBlur={handleBlur}
            />
        </Form.Group>
    );
}

export default NumberInputField;
